import addParam from '../addParam'

export default class {
  constructor(opt) {
    if (!opt.openid || !opt.openkey) {
      console.error("session_jfrp need openid,openkey params")
    }

    this.openid = opt.openid
    this.openkey = opt.openkey
  }

  getSessionParam() {
    return {
      openid: encodeURIComponent(this.openid),
      openkey: encodeURIComponent(this.openkey),
      session_id: 'jfrp_id',
      session_type: 'jfrp_key'
    }
  }

  addSessionParam(url) {
    return addParam({
      openid: encodeURIComponent(this.openid),
      openkey: encodeURIComponent(this.openkey),
      sessionid: 'jfrp_id',
      sessiontype: 'jfrp_key'
    }, url)
  }
}
